module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-DemiLight.5059bcc.eot";